// eslint-disable-next-line @nx/enforce-module-boundaries
import packageInfo from '../../../../package.json';

export const environmentBase = {
    basicat: 'ECQ',
    version: packageInfo.version,
    eclair: false,
    webview: false,
    standalone: false,
};
